import { render, staticRenderFns } from "./clubmanage.vue?vue&type=template&id=5d947fb1"
import script from "./clubmanage.vue?vue&type=script&lang=js"
export * from "./clubmanage.vue?vue&type=script&lang=js"
import style0 from "./clubmanage.vue?vue&type=style&index=0&id=5d947fb1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports